import { SingleValue } from "react-select"
import { BinInfo } from "../staticInfo/state"
import { EnquiryFormList } from "./state"

export function ChangeIsOverfilledAction(is_overfilled:boolean){
    return {
        type:'@@enquiryFormInfoState/ChangeIsOverfilledAction' as const ,
        is_overfilled
    }
}

export function ChangeIsOthersAction(is_others:boolean){
    return {
        type:'@@enquiryFormInfoState/ChangeIsOthersAction' as const ,
        is_others
    }
}

export function ChangeDistrictAction(value:string,area_id:string){
    console.log('area_id12',area_id)
    return {
        type:'@@enquiryFormInfoState/ChangeDistrictAction' as const ,
        value,
        area_id
    }
}

export function ChangeFileListAction(fileList:File[]){
    return {
        type: '@@enquiryFormInfoState/ChangeFileListAction' as const ,
        fileList
    }
}

export function ChangeDateTimeAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeDateTimeAction' as const ,
        date
    }
}

export function ChangeEnquiryTypeAction(enquiry_type_id:string){
    return {
        type: '@@enquiryFormInfoState/ChangeEnquiryTypeAction' as const ,
        enquiry_type_id
    }
}

export function ChangeCaseNoAction(case_no:string){
    return {
        type: '@@enquiryFormInfoState/ChangeCaseNoAction' as const ,
        case_no
    }
}

export function SelectBinAction(binInfo:SingleValue<BinInfo>){
    return {
        type: '@@enquiryFormInfoState/SelectBinAction' as const ,
        binInfo
    }
}

export function OthersRemarkAction(remark:string){
    return {
        type: '@@enquiryFormInfoState/OthersRemarkAction' as const ,
        remark
    }
}

export function InitEnquiryListAction(enquiryList:EnquiryFormList[]){
    return {
        type: '@@enquiryFormInfoState/InitEnquiryListAction' as const ,
        enquiryList
    }
}

export function ChnageNeedInspectionAction(need_inspection:string){
    return {
        type: '@@enquiryFormInfoState/ChnageNeedInspectionAction' as const ,
        need_inspection
    }
}

export function InitSelectedEnquiryDataAction(EnquiryList:EnquiryFormList){
    return {
        type: '@@enquiryFormInfoState/InitSelectedEnquiryDataAction' as const ,
        EnquiryList
    }
}

export function ChangeMissCallRadioAction(have_missed_call:string){
    return {
        type: '@@enquiryFormInfoState/ChangeMissCallRadioAction' as const ,
        have_missed_call
    }
}

export function ChangeHaveVoiceMessageRadioAction(have_voice_message:string){
    return {
        type: '@@enquiryFormInfoState/ChangeHaveVoiceMessageRadioAction' as const ,
        have_voice_message
    }
}

export function ChangeVoiceMessageTextAction(voice_message:string){
    return {
        type: '@@enquiryFormInfoState/ChangeVoiceMessageTextAction' as const ,
        voice_message
    }
}

export function ChangeGetBackDateAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeGetBackDateAction' as const ,
        date
    }
}

export function ChangeIsInpectedAction(is_inspected:string){
    return {
        type: '@@enquiryFormInfoState/ChangeIsInpectedAction' as const ,
        is_inspected
    }
}

export function ChangeHandleDateAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeHandleDate' as const ,
        date
    }
}

export function ChangeClearingDateAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeClearingDate' as const ,
        date
    }
}
export function ChangeReplyDateAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeReplyDateAction' as const ,
        date
    }
}

export function ChangeResultAction(result:string){
    return {
        type: '@@enquiryFormInfoState/ChangeResultAction' as const ,
        result
    }
}

export function ChangeNameAction(name:string){
    return {
        type: '@@enquiryFormInfoState/ChangeNameAction' as const ,
        name
    }
}

export function ChangeEmailAction(email:string){
    return {
        type: '@@enquiryFormInfoState/ChangeEmailAction' as const ,
        email
    }
}

export function ChangeTelAction(tel:string){
    return {
        type: '@@enquiryFormInfoState/ChangeTelAction' as const ,
        tel
    }
}

export function ClearEnquiryFormAction(){
    return {
        type: '@@enquiryFormInfoState/ClearEnquiryFormAction' as const ,
    }
}

export function ChangeDisclaimerAction(disclaimer:boolean){
    return {
        type: '@@enquiryFormInfoState/ChangeDisclaimerAction' as const ,
        disclaimer
    }
}

export function ChangeExcelStartDateAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeExcelStartDateAction' as const ,
        date
    }
}

export function ChangeExcelEndDateAction(date:Date){
    return {
        type: '@@enquiryFormInfoState/ChangeExcelEndDateAction' as const ,
        date
    }
}




export type EnquiryFormInfoAction =
|ReturnType<typeof ChangeIsOverfilledAction>
|ReturnType<typeof ChangeDistrictAction>
|ReturnType<typeof ChangeFileListAction>
|ReturnType<typeof ChangeDateTimeAction>
|ReturnType<typeof ChangeEnquiryTypeAction>
|ReturnType<typeof ChangeCaseNoAction>
|ReturnType<typeof SelectBinAction>
|ReturnType<typeof OthersRemarkAction>
|ReturnType<typeof InitEnquiryListAction>
|ReturnType<typeof ChangeIsOthersAction>
|ReturnType<typeof ChnageNeedInspectionAction>
|ReturnType<typeof InitSelectedEnquiryDataAction>
|ReturnType<typeof ChangeMissCallRadioAction>
|ReturnType<typeof ChangeHaveVoiceMessageRadioAction>
|ReturnType<typeof ChangeVoiceMessageTextAction>
|ReturnType<typeof ChangeGetBackDateAction>
|ReturnType<typeof ChangeIsInpectedAction>
|ReturnType<typeof ChangeHandleDateAction>
|ReturnType<typeof ChangeClearingDateAction>
|ReturnType<typeof ChangeReplyDateAction>
|ReturnType<typeof ChangeResultAction>
|ReturnType<typeof ChangeNameAction>
|ReturnType<typeof ChangeEmailAction>
|ReturnType<typeof ChangeTelAction>
|ReturnType<typeof ClearEnquiryFormAction>
|ReturnType<typeof ChangeDisclaimerAction>
|ReturnType<typeof ChangeExcelStartDateAction>
|ReturnType<typeof ChangeExcelEndDateAction>
